import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';

const apiCaller = getApiInstance();

function getLogsInogreen(fromDate, toDate) {
    return () => {
        return apiCaller
            .call(api.getLogsInogreen(fromDate, toDate))
            .then(result => {
                return result.data;
            })
            .catch(e => {
                Logger.log('dataActions: getLogsInogreen - ', e);
                throw e;
            });
    };
}
export { getLogsInogreen };



// WEBPACK FOOTER //
// ./environments/logging/data/LogsInogreen/actions.js